import { defineComponent as Z, mergeModels as G, useModel as _, useSlots as ee, useId as K, computed as x, ref as h, onMounted as q, watch as te, createElementBlock as m, openBlock as a, Fragment as f, createElementVNode as g, withDirectives as F, createVNode as V, unref as C, withKeys as S, withModifiers as w, vModelText as le, createBlock as B, createCommentVNode as P, renderList as U, withCtx as M, renderSlot as N, toDisplayString as j, createTextVNode as oe, vShow as ne } from "vue";
import { ScalarIconMagnifyingGlass as ie, ScalarIconPlus as ae } from "@scalar/icons";
import H from "./ScalarComboboxOption.vue.js";
import se from "./ScalarComboboxOptionGroup.vue.js";
import { isGroups as J } from "./types.js";
import de from "../ScalarListbox/ScalarListboxCheckbox.vue.js";
const ue = { class: "relative flex" }, re = ["aria-activedescendant", "placeholder"], ve = ["aria-multiselectable"], ce = { class: "inline-block min-w-0 flex-1 truncate text-c-1" }, we = /* @__PURE__ */ Z({
  inheritAttrs: !1,
  __name: "ScalarComboboxOptions",
  props: /* @__PURE__ */ G({
    options: {},
    placeholder: {},
    multiselect: { type: Boolean }
  }, {
    modelValue: { default: [] },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ G(["add"], ["update:modelValue"]),
  setup(A, { emit: Q }) {
    var D;
    const s = A, i = _(A, "modelValue"), R = Q, I = ee(), k = `scalar-combobox-items-${K()}`, p = { id: `${K()}-add`, label: "Add a new option" };
    function b(t) {
      return `${k}-${t.id}`;
    }
    const v = x(
      () => J(s.options) ? s.options.flatMap((t) => t.options) : s.options
    ), W = x(
      () => J(s.options) ? s.options : (
        /*
          We know G is an unextended OptionGroup<O> here because of the
          structure of the component props so we can cast it to G
        */
        [{ label: "", options: s.options }]
      )
      // G is OptionGroup<O>
    ), d = h(""), o = h(((D = i.value) == null ? void 0 : D[0]) ?? v.value[0]);
    q(async () => {
      var e;
      d.value = "", o.value = ((e = i.value) == null ? void 0 : e[0]) ?? v.value[0], i.value[0] && setTimeout(() => {
        var l;
        const c = i.value[0];
        c && ((l = document == null ? void 0 : document.getElementById(b(c))) == null || l.scrollIntoView({ block: "nearest" }));
      }, 10);
    }), te(
      () => d.value,
      () => o.value = E.value[0]
    );
    const y = x(
      () => d.value === "" ? v.value : v.value.filter((t) => t.label.toLowerCase().includes(d.value.toLowerCase()))
    ), E = x(
      () => I.add ? [...y.value, p] : y.value
    );
    function T(t) {
      if (t) {
        if (t.id === p.id) {
          O();
          return;
        }
        s.multiselect ? i.value.some((e) => e.id === t.id) ? i.value = i.value.filter((e) => e.id !== t.id) : i.value = [
          ...i.value,
          v.value.find((e) => e.id === t.id)
        ] : i.value = [v.value.find((e) => e.id === t.id)];
      }
    }
    function L(t) {
      var $;
      const e = E.value, l = e.findIndex((n) => {
        var u;
        return n.id === ((u = o.value) == null ? void 0 : u.id);
      }) + t;
      l < 0 || l > e.length - 1 || (o.value = e[l], o.value && (($ = document == null ? void 0 : document.getElementById(b(o.value))) == null || $.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      })));
    }
    function O() {
      R("add"), d.value = "";
    }
    const z = h(null);
    return q(() => setTimeout(() => {
      var t;
      return (t = z.value) == null ? void 0 : t.focus();
    }, 0)), (t, e) => {
      var c;
      return a(), m(f, null, [
        g("div", ue, [
          V(C(ie), { class: "pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 text-c-3 size-4" }),
          F(g("input", {
            "onUpdate:modelValue": e[0] || (e[0] = (l) => d.value = l),
            ref_key: "input",
            ref: z,
            "aria-activedescendant": o.value ? b(o.value) : void 0,
            "aria-autocomplete": "list",
            "aria-controls": k,
            class: "min-w-0 flex-1 rounded border-0 py-2.5 pl-8 pr-3 leading-none text-c-1 -outline-offset-1",
            "data-1p-ignore": "",
            placeholder: t.placeholder,
            role: "combobox",
            tabindex: "0",
            type: "text",
            onKeydown: [
              e[1] || (e[1] = S(w((l) => L(1), ["prevent"]), ["down"])),
              e[2] || (e[2] = S(w((l) => o.value && T(o.value), ["prevent"]), ["enter"])),
              e[3] || (e[3] = S(w((l) => L(-1), ["prevent"]), ["up"]))
            ]
          }, null, 40, re), [
            [le, d.value]
          ])
        ]),
        F(g("ul", {
          id: k,
          "aria-multiselectable": t.multiselect,
          class: "border-t p-0.75 custom-scroll overscroll-contain flex-1 min-h-0",
          role: "listbox",
          tabindex: "-1"
        }, [
          (a(!0), m(f, null, U(W.value, (l, $) => (a(), B(se, {
            id: `${k}-group-${$}`,
            key: $,
            hidden: (
              // Only show the group label if there are some results
              !l.options.some((n) => y.value.some((u) => u.id === n.id)) || // And it has a label
              !l.label
            )
          }, {
            label: M(() => [
              t.$slots.group ? N(t.$slots, "group", {
                key: 0,
                group: l
              }) : (a(), m(f, { key: 1 }, [
                oe(j(l.label), 1)
              ], 64))
            ]),
            default: M(() => [
              (a(!0), m(f, null, U(y.value, (n) => {
                var u;
                return a(), m(f, {
                  key: n.id
                }, [
                  l.options.some((r) => r.id === n.id) ? (a(), B(H, {
                    key: 0,
                    id: b(n),
                    active: ((u = o.value) == null ? void 0 : u.id) === n.id,
                    selected: i.value.some((r) => r.id === n.id),
                    onClick: (r) => T(n),
                    onMousedown: e[4] || (e[4] = w(() => {
                    }, ["prevent"])),
                    onMouseenter: (r) => o.value = n
                  }, {
                    default: M(({ active: r, selected: X }) => [
                      t.$slots.option ? N(t.$slots, "option", {
                        key: 0,
                        option: n,
                        active: r,
                        selected: X
                      }) : (a(), m(f, { key: 1 }, [
                        V(C(de), {
                          selected: i.value.some((Y) => Y.id === n.id),
                          multiselect: t.multiselect
                        }, null, 8, ["selected", "multiselect"]),
                        g("span", ce, j(n.label), 1)
                      ], 64))
                    ]),
                    _: 2
                  }, 1032, ["id", "active", "selected", "onClick", "onMouseenter"])) : P("", !0)
                ], 64);
              }), 128))
            ]),
            _: 2
          }, 1032, ["id", "hidden"]))), 128)),
          I.add ? (a(), B(H, {
            key: 0,
            id: b(p),
            active: ((c = o.value) == null ? void 0 : c.id) === p.id,
            onClick: O,
            onMousedown: e[5] || (e[5] = w(() => {
            }, ["prevent"])),
            onMouseenter: e[6] || (e[6] = (l) => o.value = p)
          }, {
            default: M(({ active: l }) => [
              V(C(ae), { class: "size-4 p-px" }),
              N(t.$slots, "add", { active: l })
            ]),
            _: 3
          }, 8, ["id", "active"])) : P("", !0)
        ], 8, ve), [
          [ne, y.value.length || I.add]
        ])
      ], 64);
    };
  }
});
export {
  we as default
};
